import React from 'react';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';

const NumberStatement = ({
  numberStatementData,
  header,
  backgroundColor,
  townName,
  id,
  globalWidth,
}) => {
  /* PurgeCSS include:  Yellow, White, Black */
  return (
    <div
      className={`${backgroundColor} number-statement-container`}
      id={`${id}`}
    >
      <h3
        className={`number-statement-header ${
          globalWidth && 'modular-global-width'
        }`}
      >
        <LitStructuredText data={header} basic />
        {townName && <h3>{townName}</h3>}
      </h3>

      <div
        className={`number-statement-inner ${
          globalWidth && 'modular-global-width'
        }`}
      >
        {numberStatementData?.map(
          ({ heading, featureImageDesktop, body, featureImage }, index) => {
            return (
              <div className="number-statement-content" key={index}>
                <div className="number">
                  {featureImageDesktop ||
                    (featureImage && (
                      <LitImage
                        image={featureImageDesktop ?? featureImage}
                        alt="number cartoon"
                      />
                    ))}
                  {heading && <LitStructuredText data={heading} basic />}
                </div>
                {body && (
                  <div className="statement">
                    <LitStructuredText data={body} basic />
                  </div>
                )}
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

export default NumberStatement;
